import script from "./photoGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./photoGallery.vue?vue&type=script&setup=true&lang=js"

import "./photoGallery.vue?vue&type=style&index=0&id=664768f4&lang=css"

const __exports__ = script;

export default __exports__